export default "__VITE_ASSET__82umaEi0__"